import React from 'react'
import { Link } from 'react-router-dom'
import { useI18n } from '../state/I18nContext'

const CheckoutCancel: React.FC = () => {
  const { t, locale } = useI18n()

  return (
    <section className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold">{t.checkout.title}</h1>
      <div className="mt-6 rounded-xl border border-neutral-200 p-6 bg-white">
        <p className="text-neutral-800">
          {t.checkout.canceled}
        </p>
        <div className="mt-4 flex flex-wrap gap-3">
          <Link
            to={`/${locale}/cart`}
            className="rounded-lg bg-amber-600 text-white px-5 py-3 font-semibold hover:bg-amber-700"
          >
            {t.cartPage.title}
          </Link>
          <Link
            to={`/${locale}/`}
            className="rounded-lg border border-neutral-300 px-5 py-3 font-semibold text-neutral-700 hover:bg-neutral-50"
          >
            {t.ui.home}
          </Link>
        </div>
      </div>
    </section>
  )
}

export default CheckoutCancel
